import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartRepository } from '@/core/domain/cart/repositories/cart.respository';
import { CartImplRepository } from './cart-imp.respository';
import { GetCartUseCase } from '@/core/domain/cart/usecases/getCart.usecase';
import { CreateCartInternationalUseCase } from '@/core/domain/cart/usecases/createCartInternational.usecase';

const getCartUseCaseFactory = (repository: CartRepository) =>
    new GetCartUseCase(repository);

const createCartInternationalUseCaseFactory = (repository: CartRepository) =>
    new CreateCartInternationalUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: CreateCartInternationalUseCase,
            useFactory: createCartInternationalUseCaseFactory,
            deps: [CartImplRepository],
        },
        {
            provide: GetCartUseCase,
            useFactory: getCartUseCaseFactory,
            deps: [CartImplRepository],
        },
        {
            provide: CartRepository,
            useClass: CartImplRepository,
        },
    ],
})
export class CartDataModule {}
